module.exports = __webpack_public_path__ + "img/me.8e8f14e5.gif";